export const firebaseConfig = {
  apiKey: 'AIzaSyD5J4pAED6h9FYMEYYp8pkJ4ANIIOlfR2E',
  authDomain: 'fit-gress.firebaseapp.com',
  projectId: 'fit-gress',
  storageBucket: 'fit-gress.appspot.com',
  messagingSenderId: '952195705538',
  appId: '1:952195705538:web:6b8e8903b57ae4f9be295b',
  measurementId: 'G-X9GN1ZY2TD',
};
